export default __webpack_public_path__ + "static/media/discord.23321061.png";